var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "social-status-bar",
      style: "background-color:" + _vm.publishStatus.color
    },
    [
      _c(
        "b-modal",
        {
          attrs: { type: "warn", title: "Edit Post Separately" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.unlinkDisabled
                      },
                      on: { click: _vm.clickUnlinkConfirm }
                    },
                    [
                      _vm._v(
                        "\n          Edit Separately From Master\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "danger",
                        disabled: _vm.unlinkDisabled
                      },
                      on: { click: _vm.clickUnlinkCancel }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showUnlinkModal,
            callback: function($$v) {
              _vm.showUnlinkModal = $$v
            },
            expression: "showUnlinkModal"
          }
        },
        [
          _c("p", [
            _vm._v(
              "This post will no longer be automatically updated by changes to the master post. Do you want to proceed?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { type: "warn", title: "Rejoin Master" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.relinkDisabled
                      },
                      on: { click: _vm.clickRelinkConfirm }
                    },
                    [_vm._v("\n          Rejoin Master\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "danger",
                        disabled: _vm.relinkDisabled
                      },
                      on: { click: _vm.clickRelinkCancel }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showRelinkModal,
            callback: function($$v) {
              _vm.showRelinkModal = $$v
            },
            expression: "showRelinkModal"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Content for this post will be pulled from the master post, and any content or comments specific to this post will be lost. Do you want to proceed?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { type: "warn", title: "Delete Post?" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.deleteDisabled
                      },
                      on: { click: _vm.clickDeleteConfirm }
                    },
                    [_vm._v("\n          Delete Post\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "danger",
                        disabled: _vm.deleteDisabled
                      },
                      on: { click: _vm.clickDeleteCancel }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showDeleteModal,
            callback: function($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal"
          }
        },
        [
          _c("p", [
            _vm._v(
              "This post has been manually updated. Any comments, captions, or images attached to this post will be removed. Do you want to proceed?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "social-status-bar-controls" }, [
        _vm.deliverable.manually_updated_at
          ? _c(
              "div",
              {
                staticClass: "status-bar-button",
                on: { click: _vm.clickEdit }
              },
              [_c("i", { staticClass: "fas fa-edit" })]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.deliverable.manually_updated_at
          ? _c(
              "div",
              {
                staticClass: "status-bar-button",
                on: { click: _vm.clickUnlink }
              },
              [_c("i", { staticClass: "fas fa-unlink" })]
            )
          : _c(
              "div",
              {
                staticClass: "status-bar-button",
                on: { click: _vm.clickRelink }
              },
              [_c("i", { staticClass: "fas fa-link" })]
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "status-bar-button", on: { click: _vm.clickDelete } },
          [_c("i", { staticClass: "fas fa-trash" })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }